import Analyse from './components/Analyse';
export default (props) => {
  return <Analyse {...props} />;
};
